import { createSelector } from "reselect";

import {
  getGraphData,
  getGraphDates,
  getGraphEntries1,
  getGraphParams,
  getTitle,
} from "../redux/reducersCommon/graphAndTableHelpers";
import {
  getSelectedInterval,
  getSelectedIntervalCode,
} from "../redux/reducersCommon/selectedInterval";
import {
  getItems,
  getItemsErrorMsg,
  getMeta,
  getPagination,
  getTableFilters,
  getTableQuery,
  getTableSorting,
  getTalkers,
  getThreats,
} from "./common/helpers";
import { orgIdSelector } from "./orgIdSelector";

const ipSelector = (state) => state.ip;
const selectLocation = (state) => state.location;

/*
IP ID selector
*/

const getIpId = (location) => {
  const { payload = {} } = location;

  const { id1 = "" } = payload;

  return id1;
};

// tableFiltersByOrg selector
const filtersSelector = createSelector(
  [orgIdSelector, ipSelector],
  getTableFilters
);

const getFilterValues = (filters) => {
  const { address = {}, created = {}, firstSeen = {}, lastSeen = {} } = filters;

  const { value: addressValue } = address;
  const { key: createdOption } = created;
  const { key: firstSeenOption } = firstSeen;
  const { key: lastSeenOption } = lastSeen;

  return {
    addressValue,
    createdOption,
    firstSeenOption,
    lastSeenOption,
  };
};

export const filterValuesSelector = createSelector(
  [filtersSelector],
  getFilterValues
);

// tableSorting selector
export const sortingSelector = createSelector(
  [orgIdSelector, ipSelector],
  getTableSorting
);

// Current IP Detail ID
export const idSelector = createSelector([selectLocation], getIpId);

// Interval selector
export const intervalSelector = createSelector(
  [ipSelector, idSelector],
  getSelectedInterval()
);

// Interval code selector
export const intervalCodeSelector = createSelector(
  [intervalSelector],
  getSelectedIntervalCode
);

// Graph raw data selector
export const graphDataSelector = createSelector(
  [intervalCodeSelector, ipSelector, idSelector],
  getGraphData
);

// Graph prepared data/entries selector
export const graphEntriesSelector = createSelector(
  [graphDataSelector],
  getGraphEntries1({ labelKey1: "address" })
);

// Graph dates selector
export const graphDatesSelector = createSelector(
  [intervalCodeSelector, ipSelector, idSelector],
  getGraphDates
);

// Graph params selector
export const graphParamsSelector = createSelector(
  [intervalCodeSelector, ipSelector, idSelector],
  getGraphParams
);

// IPs selector
export const ipsSelector = createSelector(
  [orgIdSelector, ipSelector],
  getItems
);

// IPs error message selector
export const ipsErrorMsgSelector = createSelector(
  [ipSelector],
  getItemsErrorMsg
);

// metaByOrg selector
export const metaSelector = createSelector(
  [orgIdSelector, ipSelector],
  getMeta
);

// paginationByOrg selector
export const paginationSelector = createSelector(
  [orgIdSelector, ipSelector],
  getPagination
);

// Selects all data required for fetching table data
export const tableQuerySelector = createSelector(
  [
    filtersSelector,
    orgIdSelector,
    paginationSelector,
    sortingSelector,
    () => null, // intervalSelector
  ],
  getTableQuery
);

// Talkers selector
export const talkersSelector = createSelector(
  [intervalCodeSelector, ipSelector, idSelector],
  getTalkers
);

// IP Detail page title
export const titleSelector = createSelector(
  [graphDataSelector],
  getTitle("address")
);

// Threats selector
export const threatsSelector = createSelector(
  [intervalCodeSelector, ipSelector, idSelector],
  getThreats
);

export const overviewSelector = () => ({});
